module.exports = __webpack_public_path__ + "img/yhlLogo.1e985f39.svg";